/**
 * DevExtreme (esm/__internal/grids/grid_core/row_dragging/dom.js)
 * Version: 23.2.10
 * Build date: Mon Oct 28 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import $ from "../../../../core/renderer";
import gridCoreUtils from "../m_utils";
import {
    CLASSES
} from "./const";
var createHandleTemplateFunc = addWidgetPrefix => (container, options) => {
    var $container = $(container);
    if ("data" === options.rowType) {
        $container.addClass(CLASSES.cellFocusDisabled);
        return $("<span>").addClass(addWidgetPrefix(CLASSES.handleIcon))
    }
    gridCoreUtils.setEmptyText($container);
    return
};
export var GridCoreRowDraggingDom = {
    createHandleTemplateFunc: createHandleTemplateFunc
};
